<template>
	<svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
			:stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
</template>

<script>
import { extractValueAndUnit } from '../../utils/iconUtils'

export default {

	name: 'IconInfo3',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},

		width_prop: {
			type: String,
			default: '1rem', // "px" or "em" only
		},

		height_prop: {
			type: String,
			default: '1rem', // "px" or "em" only
		},

		color_prop: {
			type: String,
			default: '',
		},
	},

	data() {
		return {
		}
	},

	computed: {
		color() {
			return this.color_prop || getComputedStyle(document.documentElement).getPropertyValue('--color-theme')
		},

		width() {
			const { value, unit } = extractValueAndUnit(this.width_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},

		height() {
			const { value, unit } = extractValueAndUnit(this.height_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},
	},
}
</script>

<style lang="css" scoped></style>